import { Button, Stack } from "@mui/material";
import React from "react";
import RestartAltIcon from '@mui/icons-material/RestartAlt';


function ShowMoreButtons({
  itemsToShow,
  incrementValue,
  details_by_day_length,
  handleShowAll,
  handleShowMore,
  handleReset,
  bgColor = "secondary.main",
}) {
  return (
    <Stack
      justifyContent={"center"}
      direction={"row"}
      spacing={0.5}
      sx={{ width: "100%", border: 0, }}
      alignItems={"center"}
    >
      {/* {itemsToShow != incrementValue ? (
        <Button
          onClick={handleReset}
          variant="outlined"
          startIcon={<RestartAltIcon />}
          sx={{
            borderColor: "primary.main",
            border: 2,
            color: "primary.main",
            fontWeight: 700,
          }}
        >
          Reset
        </Button>
      ) : null} */}
      {!(itemsToShow + incrementValue >= details_by_day_length) ? (
        <Button
          onClick={handleShowMore}
          variant="contained"
          sx={{ bgcolor: bgColor }}
        >
          Show{" "}
          {itemsToShow + incrementValue > details_by_day_length
            ? "here"
            : incrementValue}{" "}
          More
        </Button>
      ) : null}
      {itemsToShow < details_by_day_length ? (
        <Button
          onClick={handleShowAll}
          variant="contained"
          sx={{ bgcolor: bgColor }}
        >
          Show All {details_by_day_length}
        </Button>
      ) : null}
    </Stack>
  );
}

export default ShowMoreButtons;
